import { Assets } from '@Utils/AssetsStore';

export const JUMP_LINE_GAP = 75;
export const JUMP_BOX_PADDING_HORIZONTAL = 40;
export const JUMP_BOX_PADDING_VERTICAL = 30;
export const JUMP_TEXT_PROPS = {
  fontSize: 36,
  fontFamily: Assets.Font_Gilroy_Bold,
  lineHeight: 44 / 36,
  letterSpacing: 1.08, // 36 * 0.03
};

export const JUMP_BOX_PADDING_HORIZONTAL_MOBILE = 10;
export const JUMP_BOX_PADDING_VERTICAL_MOBILE = 7;
export const JUMP_TEXT_PROPS_MOBILE = {
  fontSize: 26,
  fontFamily: Assets.Font_Gilroy_Bold,
  lineHeight: 30 / 26,
  letterSpacing: 26 * 0.03, // 36 * 0.03
};
